import { render, staticRenderFns } from "./ButtonFkDialog.vue?vue&type=template&id=38942b1b&scoped=true"
import script from "./ButtonFkDialog.vue?vue&type=script&lang=js"
export * from "./ButtonFkDialog.vue?vue&type=script&lang=js"
import style0 from "./ButtonFkDialog.vue?vue&type=style&index=0&id=38942b1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38942b1b",
  null
  
)

export default component.exports